import { Chip, ChipProps } from '../chip';
import { useSwitchChipGroupContext } from './switch-chip-group-context';
import { SwitchChipGroupStyles } from './switch-chip.styles';

export type SwitchChipProps = Omit<ChipProps, 'onClick'> & {
  value: string;
  disabled?: boolean;
  isNew?: boolean;
};

export const SwitchChip = ({ value, disabled, isNew, ...props }: SwitchChipProps) => {
  const { value: contextValue, toggleValue, disabled: contextDisabled } = useSwitchChipGroupContext();
  const resolvedDisabled = contextDisabled || disabled;
  const selected = contextValue.includes(value);
  const styles = SwitchChipGroupStyles.switchChip({ selected, disabled: resolvedDisabled, isNew });

  return (
    <Chip
      css={styles}
      tabIndex={resolvedDisabled ? -1 : 0}
      {...props}
      onClick={
        resolvedDisabled
          ? undefined
          : (e) => {
              e.stopPropagation();
              toggleValue(value);
            }
      }
      onKeyDown={
        resolvedDisabled
          ? undefined
          : (e) => {
              if (e.key === 'Enter' || e.key === 'Space') {
                e.stopPropagation();
                toggleValue(value);
              }
            }
      }
      size='large'
      variant='outline'
    />
  );
};

SwitchChip.displayName = 'SwitchChip';
